/**
 * Puffer für Nutzungsereignisse (pure, Zeit als Parameter). Der Service
 * (services/usageTracker.ts) sendet den Inhalt gesammelt ans Backend.
 */

export const DEDUPE_MS = 2000;
export const FLUSH_GROESSE = 20;
export const MAX_BATCH = 50;

export type UsageEventType = 'page_view' | 'result_view' | 'job_start' | 'flow_start' | 'export';

export interface UsageClientEvent {
  eventType: UsageEventType;
  route?: string;
  programmeId?: string | null;
  refType?: 'job' | 'flow_execution';
  refId?: string;
  details?: Record<string, unknown>;
}

export interface PufferOptionen {
  dedupeMs?: number;
  flushGroesse?: number;
  maxBatch?: number;
}

export function erstellePuffer(opt: PufferOptionen = {}) {
  const dedupeMs = opt.dedupeMs ?? DEDUPE_MS;
  const flushGroesse = opt.flushGroesse ?? FLUSH_GROESSE;
  const maxBatch = opt.maxBatch ?? MAX_BATCH;
  let events: UsageClientEvent[] = [];
  let letzterPageView: { route: string | undefined; ms: number } | null = null;

  return {
    /** false bei Duplikat (gleicher page_view + Route innerhalb dedupeMs). */
    add(event: UsageClientEvent, nowMs: number): boolean {
      if (event.eventType === 'page_view') {
        if (letzterPageView && letzterPageView.route === event.route && nowMs - letzterPageView.ms < dedupeMs) {
          return false;
        }
        letzterPageView = { route: event.route, ms: nowMs };
      }
      events.push(event);
      return true;
    },
    sollteFlushen(): boolean {
      return events.length >= flushGroesse;
    },
    /** Leert den Puffer und liefert höchstens maxBatch Events (Rest wird verworfen — Tracking darf nie stauen). */
    take(): UsageClientEvent[] {
      const out = events.slice(0, maxBatch);
      events = [];
      return out;
    },
    get size(): number {
      return events.length;
    },
  };
}
